import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'TOSSXTOSS',
  description:
    'The most popular AMM on BSC by user count! Earn CAKE through yield farming or win it in the Lottery, then stake it in CTOS Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by CTOS), NFTs, and more, on a platform you can trust.',
  image: 'https://thekingslife.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `TOSSXTOSS | ${t('Home')}`,
      }
    case '/swap':
      return {
        title: `TOSSXTOSS | ${t('Exchange')}`,
      }
    case '/add':
      return {
        title: `TOSSXTOSS | ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `TOSSXTOSS | ${t('Remove Liquidity')}`,
      }
    case '/liquidity':
      return {
        title: `TOSSXTOSS | ${t('Liquidity')}`,
      }
    case '/find':
      return {
        title: `TOSSXTOSS | ${t('Import Pool')}`,
      }
    case '/competition':
      return {
        title: `TOSSXTOSS | ${t('Trading Battle')}`,
      }
    case '/prediction':
      return {
        title: `TOSSXTOSS | ${t('Prediction')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `TOSSXTOSS | ${t('Leaderboard')}`,
      }
    case '/farms':
      return {
        title: `TOSSXTOSS | ${t('Farms')}`,
      }
    case '/farms/auction':
      return {
        title: `TOSSXTOSS | ${t('Farm Auctions')}`,
      }
    case '/pools':
      return {
        title: `TOSSXTOSS | ${t('Pools')}`,
      }
    case '/lottery':
      return {
        title: `TOSSXTOSS | ${t('Lottery')}`,
      }
    case '/ifo':
      return {
        title: `TOSSXTOSS | ${t('Initial Farm Offering')}`,
      }
    case '/teams':
      return {
        title: `TOSSXTOSS | ${t('Leaderboard')}`,
      }
    case '/voting':
      return {
        title: `TOSSXTOSS | ${t('Voting')}`,
      }
    case '/voting/proposal':
      return {
        title: `TOSSXTOSS | ${t('Proposals')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `TOSSXTOSS | ${t('Make a Proposal')}`,
      }
    case '/info':
      return {
        title: `TOSSXTOSS | ${t('Overview')} | ${t('TOSSXTOSS Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/pools':
      return {
        title: `TOSSXTOSS | ${t('Pools')} | ${t('TOSSXTOSS Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `TOSSXTOSS | ${t('Tokens')} | ${t('TOSSXTOSS Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/nfts':
      return {
        title: `TOSSXTOSS | ${t('Overview')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')}`,
      }
    default:
      return null
  }
}
